import styled from "../../config/styles";

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding-right: 1rem;
  padding-left: 1rem;
`;

export default Container;
